import proprietaryModelForFilter from '@/mixins/proprietary-model-for-filter';
import { CHANNELS_FILTER_TRANSLATE } from '@/store/modules/cards/constants';

const CHANNELS_VISIBLE_IN_PAGE_FILTER = ['tiktok', 'youtube'];

export default {
  mixins: [
    proprietaryModelForFilter,
  ],
  data() {
    return {
      alertMessage: this.$t('mixins.pagesModel.alert.alertMessage'),
      linkText: this.$t('mixins.pagesModel.alert.linkText'),
      linkReference: 'https://stilingue.com.br/termo-de-uso-do-dashboards-by-studio-stilingue',
    };
  },
  computed: {
    pagesFormatted() {
      if (!this.pages) {
        return [];
      }

      const channelsFiltered = [];

      if (this.card?.control) {
        const cardControlEntries = Object.entries(this.card.control);

        cardControlEntries.forEach((channelInfo) => {
          if (!CHANNELS_VISIBLE_IN_PAGE_FILTER.includes(channelInfo[0]) &&
            channelInfo[0] in CHANNELS_FILTER_TRANSLATE &&
            Boolean(channelInfo[1]?.hideInChannel)) {
            channelsFiltered.push(CHANNELS_FILTER_TRANSLATE[channelInfo[0]]);
          }
        }
        );

        const filterByPage = this.pages.filter((page) => {
          return !channelsFiltered.includes(page.channel);
        });

        return filterByPage.map(page => ({
          text: page.title,
          value: page.id,
          channel: page.channel,
          username: page.username,
          id: page.page_id,
        }));
      }

      return this.pages.map(page => ({
        text: page.title,
        value: page.id,
        channel: page.channel,
        username: page.username,
      }));
    },
    allUniqueChannels() {
      return Array.from(new Set(this.pagesFormatted.map(page => page.channel)));
    },
    pagesSelected: {
      get() {
        return this.tempFilter.pages || { value: [] };
      },
      set(newValue) {
        const newPages = newValue ? newValue.value : [];
        if (!newPages || !newPages.length) {
          delete this.tempFilter.channels;
          delete this.tempFilter.pages;

          this.channels = [];
          return;
        }

        const pageChannels = [];
        newPages.forEach(newPageId => {
          const foundPage = this.pages.find(page => page.id === newPageId);
          if (foundPage) {
            pageChannels.push(foundPage.channel);
          }
        });

        const channels = Array.from(new Set(pageChannels));
        this.tempFilter.channels = {
          value: channels,
        };
        this.channels = channels;

        const ids = Array.from(new Set(newPages));
        this.tempFilter.pages = {
          value: ids,
        };
      },
    },
  },
};
